import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import VertexSelectionDialog from './VertexSelectionDialog';
import EventTreeTransferGateVertex from '../../../../../mxGraph/HCLTreeNode/EventTreeNode/EventTreeTransferGateNode/EventTreeTransferGateVertex';
import LabelInput from '../Inputs/LabelInput';
import OutcomeInput from '../Inputs/OutcomeInput';
import Label, {LabelJSON} from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Label';
import Outcome, {OutcomeJSON} from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Outcome';
import HclApiManager from '../../../../../Api/HclApiManager';
import TreePickerDialog from "./TreePickerDialog";
import { TreeTypes } from '../Tools/TreeDictionaries';
import createStyles from "@material-ui/core/styles/createStyles";
import EventTreeTransferGateVertexValue
  from "../../../../../mxGraph/HCLTreeNode/EventTreeNode/EventTreeTransferGateNode/EventTreeTransferGateVertexValue";
import FaultTreeTransferGateVertexValue
  from "../../../../../mxGraph/HCLTreeNode/FaultTreeNode/FaultTreeTransferGateNode/FaultTreeTransferGateVertexValue";
import Formula from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Formula";

const styles = () => createStyles({
  nodeData: {
    textAlign: 'center',
  },
  nodeOutline: {
    backgroundColor: 'pink',
    height: '210px',
  },
  selectBtn: {
    marginTop: '5px',
  },
});

interface Props {
  vertex: EventTreeTransferGateVertex;
  onClose: () => void;
  onSave: () => void;
}

interface State {
  label: LabelJSON;
  labelError: boolean;
  outcome: OutcomeJSON;
}

class EventTreeTransferGateSelectionDialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { vertex } = this.props;
    const value = vertex.getValue() as EventTreeTransferGateVertexValue;

    this.state = {
      label: value.getLabel().toJSON(),
      labelError: false,
      outcome: value.getOutcome().toJSON()
    };
  }

  handleSave = () => {
    const { vertex, onSave } = this.props;
    const { label, outcome } = this.state;
    const value = vertex.getValue() as FaultTreeTransferGateVertexValue;
    value.setLabel(Label.build(label));
    value.setFormula(new Formula(outcome));

    onSave()
  };

  private handleLabelError = (error: boolean) => {
    this.setState({ labelError: error });
  };

  /**
   * handle input change of text fields
   * @param {Object} e - event object
   * @param {string} key - This tells us which text field the event is coming from.
   *  Specified by name field of {@link LabelInput} and {@link OutcomeInput}
   */
  handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, key: string) => {
    e.persist();
    // @ts-ignore
    this.setState(state => ({
      [key]: {
        // @ts-ignore
        ...state[key],
        [e.target.name]: e.target.value,
      },
    }));
  };

  render() {
    const { vertex, onClose } = this.props;
    const { label, outcome, labelError } = this.state;

    return (
      <Fragment>
        <VertexSelectionDialog
          vertex={vertex}
          onClose={onClose}
          onSave={this.handleSave}
          error={labelError}
          open
          maxWidth="lg"
          fullWidth
        >
          <LabelInput
            label={Label.build(label)}
            onChange={this.handleChange}
            onError={this.handleLabelError}
            name="label"
            gridItemProps={{
              xs: 12,
              sm: 4,
            }}
          />
          <OutcomeInput
            outcome={Outcome.build(outcome)}
            onChange={this.handleChange}
            name="outcome"
            disabled
            treeTypesToShow={TreeTypes.EVENT_TREE}
          />
        </VertexSelectionDialog>
      </Fragment>
    );
  }
}

export default withStyles(styles)(EventTreeTransferGateSelectionDialog);
